import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getGuestVisit = fp.get('guest.visit');

export const getAll = createSelector(getGuestVisit, fp.get('all'));

export const getAllValues = createSelector(getAll, fp.values);

export const getFetching = createSelector(getGuestVisit, fp.get('fetching'));
export const getFetched = createSelector(getGuestVisit, fp.get('fetched'));
export const getFetchingError = createSelector(
  getGuestVisit,
  fp.get('fetchingError')
);

export const getSaving = createSelector(getGuestVisit, fp.get('saving'));

export const getSaved = createSelector(getGuestVisit, fp.get('saved'));

export const getSavingError = createSelector(
  getGuestVisit,
  fp.get('savingError')
);

export const getOrder = createSelector(getGuestVisit, fp.get('order'));
